import { render, staticRenderFns } from "./equi.vue?vue&type=template&id=edc0fd5a&scoped=true"
import script from "./equi.vue?vue&type=script&lang=js"
export * from "./equi.vue?vue&type=script&lang=js"
import style1 from "./equi.vue?vue&type=style&index=1&id=edc0fd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc0fd5a",
  null
  
)

export default component.exports